export const OrderInfoCardList = [
    {
        field: 'title',
        // name: '單號:'
    },
    {
        field: 'publicId',
        name: '單號:'
    },
    {
        field: 'email',
        name: 'Email:'
    },
    {
        field: 'phone',
        name: '電話:'
    },
    {
        field: 'address',
        name: '地址:'
    },
    {
        field: 'deliveryDate',
        name: '配送日期:'
    },
    {
        field: 'furnitureCount',
        name: '家具數量:'
    },
    {
        field: 'weight',
        name: '總重量(kg):'
    },
    {
        field: 'invoiceAmount',
        name: '發票金額:'
    },
    {
        field: 'deliveryFee',
        name: '運費:'
    },
    {
        field: 'isShipped',
        name: '寄送狀態:'
    },
    {
        field: 'status',
        name: '審核狀態:'
    },
];

export const RecordsInfoCardList = [
    {
        field: 'title',
        // name: '單號:'
    },
    {
        field: 'deliverName',
        name: '司機:'
    },
    {
        field: 'mapUrl',
        name: 'GoogleMap'
    },
    {
        field: 'deliveryDate',
        name: '配送日期:'
    },
    {
        field: 'drivingKm',
        name: '行駛距離(km):'
    },
    {
        field: 'longDrivingKm',
        name: '最長距離(km):'
    },
    {
        field: 'drivingTime',
        name: '行駛時間:'
    },
    {
        field: 'weight',
        name: '重量:'
    },
    {
        field: 'carbonReduction',
        name: '減碳量:'
    },
    {
        field: 'status',
        name: '運送狀態:'
    },
    {
        field: 'orderId',
        name: '訂單:'
    },
];

export const StaffOrderInfoCardList = [
    {
        field: 'title',
        // name: '單號:'
    },
    {
      field: 'publicId',
        name: '單號:'  
    },
    {
        field: 'company',
        name: '公司:'
    },
    {
        field: 'name',
        name: '司機:'
    },
    // {
    //     field: 'phone',
    //     name: '手機號碼:'
    // },
    {
        field: 'plate',
        name: '車牌:'
    },
    {
        field: 'furnitureCount',
        name: '家具數量:'
    },
    {
        field: 'usedAt',
        name: '使用時間:'
    },
    {
        field: 'finishAt',
        name: '結束時間:'
    },
    {
        field: 'returnAt',
        name: '歸還時間:'
    },
    {
        field: 'status',
        name: '派送狀態:'
    }
];